import type {
  IUserSwitchAccountRequest,
  IUserSwitchAccountResponse,
} from '@/app-package';

import axios from 'axios';

const switchAccount = async (id: string) => {
  const config: IUserSwitchAccountRequest = {
    url: `user/switch-account/${id}`,
    method: 'post',
  };

  await axios.request<IUserSwitchAccountResponse>(config);
};

export default switchAccount;
